import styled from 'styled-components'

export const UserInfoContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};

  & > button {
    min-width: ${props => props.theme.size.L};
  }
`

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  flex: 1 0 0;
  cursor: pointer;
`

export const Image = styled.img`
  min-width: ${props => props.theme.size.L};
  height: ${props => props.theme.size.L};
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
  object-fit: cover;
`

export const NameAndAlias = styled.div`
  display: grid;
  gap: ${props => props.theme.spacing.sp4};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
`
